// data/PoliciesSchemas.js
import { width } from "@mui/system";
import FingerprintIcon from "@mui/icons-material/Fingerprint";

import { DATE_FORMAT_REG_EXP } from "utils/datetime";
export const PoliciesRenewSchemas = [
  {
    id: "mode",
    dataType: "Text",
    shownOnForm: true,
    width: "60%",
    label: "Mode",
    value: "Renew",
    isRequired: true,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "Renew", label: "Renew" },
      { value: "Activation", label: "Activation" },
      { value: "Suspension", label: "Suspension" },
      { value: "Deletion", label: "Deletion" },
    ],
  },
  {
    id: "bulk_upload_file",
    label: "Upload File",
    fieldType: "file",
    shownOnForm: true,
    isRequired: false,
    width: "100%",
    accept: ".xlsx,.xls", // Accepted file types
    multiple: false, // Single file upload
    maxSize: 5 * 1024 * 1024, // 5MB max size
    helperText: "Upload policies excel file (XLSX, XLS up to 5MB)",
    showDownloadTemplate: true,
    downloadTemplateLabel: "Download Template",
    onDownloadTemplate: "onDownloadTemplate",
  },
  {
    id: "expiryDatetime",
    dataType: "Text",
    shownOnForm: (formData) => formData.mode === "Renew",
    width: "60%",
    label: "New Expiry Date",
    value: "2026-12-31",
    isRequired: true,
    fieldType: "date",
    pattern: DATE_FORMAT_REG_EXP,
    helperText: "This field only applies if you are renewing policies",
  },
  {
    id: "benefits",
    label: "Policy Benefits & Limits",
    fieldType: "dynamicList",
    shownOnForm: (formData) => formData.mode === "Renew",
    isRequired: false,
    isFixedList: true,
    helperText: "Update the policy benefits on renewal",
    columns: [
      {
        id: "policyItemId",
        label: "Benefit Item",
        type: "select",
        isRequired: true,
        // Add these three lines:
        optionsKey: "availablePolicyItems",
        valueKey: "id",
        textValue: "label",
      },
      {
        id: "limit",
        label: "Amount Limit",
        type: "number",
        isRequired: true,
        helperTextKey: "balance",
        helperTextVal: (balance) => {
          if (balance === null || balance === undefined) {
            return "";
          }
          return `Bal: ${balance.toLocaleString("en-US")}`;
        },
        sx: {
          mt: 0.5,
          fontSize: "0.75rem",
          color: "#953305",
          fontWeight: "bold",
        },
      },
      {
        id: "countLimit",
        label: "Count Limit",
        type: "number",
        isRequired: true,
        helperTextKey: "countBalance",
        helperTextVal: (countBalance) => {
          if (countBalance === null || countBalance === undefined) {
            return "";
          }
          return `Visits: ${countBalance}`;
        },
        sx: {
          mt: 0.4,
          fontSize: "0.65rem",
          color: "#033c6b",
          fontWeight: "bold",
        },
      },
    ],
  },
];

export const policiesRenewRecord = {
  id: null,
  mode: "",
  expiryDatetime: "",
  benefits: [],
};
